import { IPresenterProps } from './types';
import * as S from './styles';
import Map from '../../components/Map/Container';
import BusinessList from '../../components/BusinessList/Container';
import { useMediaQuery } from '../../utils/CustomHooks/MediaQuery';
import NavBar from '../../components/NavBar2/Container'
import { useTheme } from 'styled-components';

const SearchPresenter = (props: IPresenterProps) => {
    const theme = useTheme();
    let matches = useMediaQuery(`(min-width: ${theme.screenSizes.tablet})`);

    return (
        <>
            <NavBar
                searchBarData={props.searchBarData}
                selectedCategories={props.selectedCategories}
                changeNavbar={props.changeNavbar}
                isBigNavVisible={props.isBigNavVisible}
                // SearchBar props
                formData={props.formData}
                onChange={props.onChange}
                isBtnDisabled={props.isBtnDisabled}
                searchResults={props.searchResults}
                isCategoriesBoxVisible={props.isCategoriesBoxVisible}
                toggleCategoriesBoxVisibility={props.toggleCategoriesBoxVisibility}
                searchBusinessCategories={props.searchBusinessCategories}
                addCategory={props.addCategory}
                removeCategory={props.removeCategory}
                isDatePickerVisible={props.isDatePickerVisible}
                toggleDatePickerVisibility={props.toggleDatePickerVisibility}
                selectedDate={props.selectedDate}
                handleSelectDate={props.handleSelectDate}
                isLocationBoxVisible={props.isLocationBoxVisible}
                toggleLocationBoxVisibility={props.toggleLocationBoxVisibility}
                searchLocations={props.searchLocations}
                searchHoodResults={props.searchHoodResults}
                selectLocation={props.selectLocation}
            />
            <S.PageContainer>
                <S.InfoSide>
                    {props.isLoading ? (
                        <S.MessageContainer>
                            <S.Message>Cargando negocios...</S.Message>
                        </S.MessageContainer>
                    ) : props.error ? (
                        <S.MessageContainer>
                            <S.ErrorMessage>Error al cargar los negocios. Por favor, intenta nuevamente.</S.ErrorMessage>
                        </S.MessageContainer>
                    ) : props.businesses.length === 0 ? (
                        <S.MessageContainer>
                            <S.Message>No se encontraron negocios que coincidan con tu búsqueda.</S.Message>
                            <S.SubMessage>Intenta ajustar tus filtros o buscar en otra ubicación.</S.SubMessage>
                        </S.MessageContainer>
                    ) : (
                        <BusinessList businesses={props.businesses} bussinessClickedIndex={props.bussinessClicked} />
                    )}
                </S.InfoSide>

                {matches && !props.isLoading && !props.error &&
                    <S.MapSide>
                        <Map businesses={props.businesses} handleBusinessClicked={props.handleBusinessClicked} />
                    </S.MapSide>
                }
            </S.PageContainer>
        </>
    )
};

export default SearchPresenter;
